// @ts-nocheck

import { defineAsyncComponent } from 'vue';
import { defineSliceZoneComponents } from '@prismicio/vue';

export const components = defineSliceZoneComponents({
  account_banner: defineAsyncComponent(
    () => import('./AccountBanner/index.vue')
  ),
  banner: defineAsyncComponent(() => import('./Banner/index.vue')),
  footer_external_links: defineAsyncComponent(
    () => import('./FooterExternalLinks/index.vue')
  ),
  footer_social_links: defineAsyncComponent(
    () => import('./FooterSocialLinks/index.vue')
  ),
  global_notification: defineAsyncComponent(
    () => import('./GlobalNotification/index.vue')
  ),
  portfolio_banner: defineAsyncComponent(
    () => import('./PortfolioBanner/index.vue')
  ),
  upcoming_pool: defineAsyncComponent(() => import('./UpcomingPool/index.vue')),
});
